import { useLocalObservable } from 'mobx-react-lite';
import { RefObject, useEffect } from 'react';
import { View } from 'react-big-calendar';

export interface IAllDayMaxRowsPresenter {
  allDayMaxRows: number | undefined;
  currentView: View | null;
  setAllDayMaxRows(value: number | undefined): void;
  resetAllDayMaxRows(): void;
  setWeekAllDayMaxRows(): void;
  setCurrentView(currentView: View): void;
  onShowMore(): void;
}

interface IAllDayMaxRowsPresenterParams {
  calRef: RefObject<HTMLDivElement>;
}

export const useAllDayMaxRowsPresenter = (
  props: IAllDayMaxRowsPresenterParams
): IAllDayMaxRowsPresenter => {
  const { calRef } = props;

  const presenter = useLocalObservable<IAllDayMaxRowsPresenter>(() => ({
    allDayMaxRows: 4,
    currentView: null,

    setAllDayMaxRows(value: number | undefined): void {
      presenter.allDayMaxRows = value;
    },

    resetAllDayMaxRows(): void {
      presenter.setAllDayMaxRows(undefined);
    },

    setWeekAllDayMaxRows(): void {
      presenter.setAllDayMaxRows(4);
    },

    setCurrentView(currentView: View): void {
      presenter.currentView = currentView;
    },

    onShowMore(): void {
      presenter.setAllDayMaxRows(undefined);
    },
  }));

  useEffect(() => {
    const root = calRef.current;

    if (!root) {
      return;
    }

    // В дневном/недельном виде вертикальный скролл именно тут
    const scroller = root.querySelector<HTMLElement>('.rbc-time-content');
    if (!scroller) {
      return;
    }

    // Игнорим автоскролл от scrollToTime при монтировании
    let ready = false;
    const readyTimer = setTimeout(() => (ready = true), 200);

    const onScroll = (): void => {
      if (!ready) {
        return;
      }
      presenter.setAllDayMaxRows(4);
    };

    scroller.addEventListener('scroll', onScroll, { passive: true });
    return (): void => {
      clearTimeout(readyTimer);
      scroller.removeEventListener('scroll', onScroll);
    };
  }, [calRef.current, presenter.currentView]);

  return presenter;
};
